import { render, staticRenderFns } from "./EmbeddedNewCopiedDocumentEditView.vue?vue&type=template&id=622b332b&scoped=true&"
import script from "./EmbeddedNewCopiedDocumentEditView.vue?vue&type=script&lang=ts&"
export * from "./EmbeddedNewCopiedDocumentEditView.vue?vue&type=script&lang=ts&"
import style0 from "./EmbeddedNewCopiedDocumentEditView.vue?vue&type=style&index=0&id=622b332b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622b332b",
  null
  
)

export default component.exports